import { render, staticRenderFns } from "./BlockedAddress.vue?vue&type=template&id=628e7e99&scoped=true"
import script from "./BlockedAddress.vue?vue&type=script&lang=js"
export * from "./BlockedAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e7e99",
  null
  
)

export default component.exports